import { generatePath, useNavigate } from "react-router-dom"
import { computed } from "mobx"
import { observer } from "mobx-react-lite"
import { Form, Table } from "antd"
import { useForm } from "antd/es/form/Form"
import { ColumnsType } from "antd/es/table"

import {
  TokensCollection,
  TokenType,
} from "@src/pages/settingsApiKeys/classes/TokensCollection"
import { TokensTableActions } from "@src/pages/settingsApiKeys/ui/TokensTableActions"
import { TokensTableExpand } from "@src/pages/settingsApiKeys/ui/TokensTableExpand"
import { WithCollection } from "@src/shared/classes/Collection/types"
import { paddingLimit } from "@src/shared/strings"

const TokenId = observer(
  ({ tokens, v }: { tokens: TokensCollection; v: any }) => {
    return tokens.isVisibleId(v) ? v : paddingLimit(v, 0, 8)
  },
)

type Props = WithCollection<TokensCollection> & {}
export const TokensTable = observer(({ collection }: Props) => {
  const columns = computed(() => {
    return [
      {
        align: "center",
        dataIndex: "name",
        title: "Name",
        width: "45%",
      },
      {
        align: "center",
        key: "id",
        render: (_, { id }) => <TokenId tokens={collection} v={id} />,
        title: "API Key",
        width: "45%",
      },
      {
        align: "center",
        render: (_, { id }) => (
          <TokensTableActions collection={collection} id={id} />
        ),
        title: "Action",
        width: "10%",
      },
    ] as ColumnsType<TokenType>
  }).get()

  return (
    <Table
      columns={columns}
      dataSource={collection.items}
      expandable={{
        expandedRowRender: (record) => (
          <TokensTableExpand
            groups={collection.scopes.groups}
            record={record}
          />
        ),
      }}
      loading={collection.isLoading}
      pagination={collection.pagination}
      rowKey="id"
    />
  )
})
